import { all_routes } from "../../../feature-module/router/all_routes";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const routes = all_routes;

// Custom hook to get sidebar data with location verification status
export const useSidebarData = () => {
  // Get location verification status from Redux store
  const isLocationVerified = useSelector((state: RootState) => state.userLocation.isLocationVerified);

  return [
    {
      role: ["admin"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Admin",
          link: routes.adminGrid,
          icon: "fa-regular fa-user",
          submenu: false,

        },
        {
          label: "Add region",
          link: routes.addState,
          icon: "ti ti-user-star",
          submenu: false,
        },
        {
          label: "Schools",
          link: routes.schoolGrid,
          icon: "ti ti-building-community",
          submenu: false,
        },
        {
          label: "Reports",
          link: routes.stateMealReport,
          icon: "ti ti-school",
          submenu: false,
        },
      ],
    },
    {
      role: ["state-admin"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Admin",
          link: routes.adminGrid,
          icon: "fa-regular fa-user",
          submenu: false,

        },
        {
          label: "Add Region",
          link: routes.addDistrictBlockVillage,
          icon: "ti ti-user-star",
          submenu: false,

        },
        {
          label: "Schools",
          link: routes.schoolGrid,
          icon: "ti ti-building-community",
          submenu: false,
        },
        {
          label: "Reports",
          link: routes.stateMealReport,
          icon: "ti ti-school",
          submenu: false,
        },
      ],
    },
    {
      role: ["district-admin"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Admin",
          link: routes.adminGrid,
          icon: "fa-regular fa-user",
          submenu: false,

        },
         {
          label: "Add Region",
          link: routes.addBlockVillage,
          icon: "ti ti-user-star",
          submenu: false,

        },
        {
          label: "Schools",
          link: routes.schoolGrid,
          icon: "ti ti-building-community",
          submenu: false,
        },
        {
          label: "Reports",
          link: routes.stateMealReport,
          icon: "ti ti-school",
          submenu: false,
        },
      ],
    },
    {
      role: ["block-admin"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Admin",
          link: routes.adminGrid,
          icon: "fa-regular fa-user",
          submenu: false,

        },
         {
          label: "Add Region",
          link: routes.addVillage,
          icon: "ti ti-user-star",
          submenu: false,

        },
        {
          label: "Schools",
          link: routes.schoolGrid,
          icon: "ti ti-building-community",
          submenu: false,
        },
        {
          label: "Reports",
          link: routes.stateMealReport,
          icon: "ti ti-school",
          submenu: false,
        },
      ],
    },
    {
      role: ["village-admin"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Admin",
          link: routes.adminGrid,
          icon: "fa-regular fa-user",
          submenu: false,

        },
        {
          label: "Schools",
          link: routes.schoolGrid,
          icon: "ti ti-building-community",
          submenu: false,
        },
        {
          label: "Reports",
          link: routes.stateMealReport,
          icon: "ti ti-school",
          submenu: false,
        },
      ],
    },
    {
      role: ["mealSupervisor"],
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.mealSupervisor,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Meals",
          link: routes.studentMeals,
          icon: "ti ti-calendar-check",
          submenu: false,
        },

        {
          label: "Reports",
          link: "#",
          icon: "ti ti-report",
          submenu: true,
          subMenus: [
            {
              label: "Meal Report",
              link: routes.reportMeals,
              icon: "ti ti-report",
            },
            {
              label: "Exception Report",
              link: routes.mealExceptionReport,
              icon: "ti ti-users",
            },
          ]
        },
      ],
    },
    {
      role: ["teacher"],
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.teacherDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Students",
          link: routes.studentGrid,
          icon: "ti ti-users",
          submenu: false,
        },

        // Only show Attendance and Meals if location is verified
        ...(isLocationVerified === false ? [
          {
            label: "Attendance",
            link: routes.studentAttendance,
            icon: "ti ti-calendar-check",
            submenu: false,
          },
          {
            label: "Meals",
            link: routes.studentMeals,
            icon: "ti ti-calendar-check",
            submenu: false,
          },
        ] : []),
       
        {
          label: "Reports",
          link: "#",
          icon: "ti ti-report",
          submenu: true,
          subMenus: [
            {
              label: "Meal Report",
              link: routes.reportMeals,
              icon: "ti ti-report",
            },
            {
              label: "Exception Report",
              link: routes.mealExceptionReport,
              icon: "ti ti-users",
            },
          ]
        }
      ],
    },
    {
      role: ["hm"],
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.HeadmasterDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Teachers",
          link: routes.teacherGrid,
          icon: "ti ti-user-star",
          submenu: false,
        },
        {
          label: "Teachers Attendance",
          link: routes.teacherAttendanceList,
          icon: "ti ti-calendar-check",
          submenu: false,
        },
        {
          label: "Classes",
          link: routes.classes,
          icon: "ti ti-school",
          submenu: false,
        },
        {
          label: "Sections",
          link: routes.sections,
          icon: "ti ti-section",
          submenu: false,
        },
        {
          label: "Students",
          link: routes.studentGrid,
          icon: "ti ti-users",
          submenu: false,
        },
        {
          label: "Report",
          link: routes.reportMeals,
          icon: "ti ti-report",
          SubMenu: false
        }
      ],
    },
  ];
};

// Legacy function for backward compatibility (without location verification)
export const getSidebarData = () => {
  return [
    {
      role: ["Teacher"], // roles that can see this group
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.teacherDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Students",
          link: routes.studentGrid,
          icon: "ti ti-users",
          submenu: false,
        },
        {
          label: "Attendance",
          link: routes.studentAttendance,
          icon: "ti ti-calendar-check",
          submenu: false,
        },
        {
          label: "Meals",
          link: routes.studentMeals,
          icon: "ti ti-calendar-check",
          submenu: false,
        },
        {
          label: "Geo-Location",
          link: routes.teacherLocation,
          icon: "ti ti-world",
          submenu: false,
        },
        {
          label: "Reports",
          link: "#",
          icon: "ti ti-report",
          submenu: true,
          subMenus: [
            {
              label: "Meal Report",
              link: routes.reportMeals,
              icon: "ti ti-utensils",
            },
          ]
        }
      ],
    },
    {
      role: ["hm"],
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.HeadmasterDashboard,
          icon: "ti ti-home",
          submenu: false,
        },
        {
          label: "Teachers",
          link: routes.teacherGrid,
          icon: "ti ti-user-star",
          submenu: false,
        },
        {
          label: "Teachers Attendance",
          link: routes.teacherAttendanceList,
          icon: "ti ti-calendar-check",
          submenu: false,
        },
        {
          label: "Classes",
          link: routes.classes,
          icon: "ti ti-school",
          submenu: false,
        },
        {
          label: "Sections",
          link: routes.sections,
          icon: "ti ti-section",
          submenu: false,
        },
        {
          label: "Students",
          link: routes.studentGrid,
          icon: "ti ti-users",
          submenu: false,
        },
      ],
    },
  ];
};